import React from 'react'

export default class ShowMath extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isShowMath: false
    }
  }

  _onCheck () {
    const isShowMath = !this.state.isShowMath

    this.setState({isShowMath})
  }

  render () {
    const { isShowMath } = this.state
    const { personalTotal, personalTax, personalTip } = this.props

    return (
      <div>
        <label>Show math?
          <input type="checkbox" checked={isShowMath} onClick={() => this._onCheck()} />
          {isShowMath &&
            <div>
              <p>Personal Subtotal ${personalTotal.toFixed(2)}</p>
              <p>Personal Tax ${personalTax.toFixed(2)}</p>
              <p>Personal Tip ${personalTip.toFixed(2)}</p>
            </div>
          }
        </label>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/components/ShowMath.js
 **/